export { PrivacyPolicy } from './PrivacyPolicy'
export { TermsOfService } from './TermsOfService'
